import { render, staticRenderFns } from "./DialogBase.vue?vue&type=template&id=5cbe1a72"
import script from "./DialogBase.vue?vue&type=script&lang=ts"
export * from "./DialogBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports